import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, TextField, Button, Grid } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchItCategory, updateItCategory, fetchItType } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function ItCategoryEditPage() {
  const { businessDomainId, categoryId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [original, setOriginal] = useState(null);
  const [itTypeName, setItTypeName] = useState("");
  const [form, setForm] = useState({ itCategoryName: "", itCategoryDescription: "", url: "" });

  const loadData = useCallback(async () => {
    try {
      const d = await fetchItCategory(categoryId);
      setOriginal(d);
      setForm({
        itCategoryName: d.itCategoryName || "",
        itCategoryDescription: d.itCategoryDescription || "",
        url: d.url || "",
      });
      if (d.itTypeId) {
        const it = await fetchItType(d.itTypeId);
        setItTypeName(it.itTypeName || "");
      }
    } catch (e) { notify.apiError(e); }
  }, [categoryId]);

  useEffect(() => { loadData(); }, [loadData]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!original) return;
    try {
      await updateItCategory(categoryId, { ...original, ...form });
      notify.success(t("message.update.success"));
      navigate(`/strategy/${businessDomainId}/it-categories/${categoryId}`);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("itCategory.edit.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField fullWidth disabled label={t("itCategory.itType")} value={itTypeName} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth required label={t("itCategory.name")}
              name="itCategoryName" value={form.itCategoryName} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth label={t("common.url")}
              name="url" value={form.url} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth multiline rows={3} label={t("common.description")}
              name="itCategoryDescription" value={form.itCategoryDescription} onChange={handleChange} />
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.save")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/it-categories/${categoryId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
